export default "__VITE_ASSET__DNx0UyNg__"